import { useEffect } from 'react';
import type { Helix2000Character } from '../../../../shared/CharacterTypes';
import { featuredQuestIds, hydrateNpcDialogue, type NpcDialoguePayload } from '../../npc/hydrateNpcDialogue';
import { DiscoveredQuestsStore } from './DiscoveredQuestsStore';
import { questJournalOwner } from './questJournalFocus';

/** When an NPC reply arrives, remember the featured chapters it showed — for this character only. */
export function useRecordDiscoveredQuests(payload: NpcDialoguePayload | null | undefined, player: Helix2000Character | null | undefined): void {
  const owner = questJournalOwner(player);
  useEffect(() => {
    if (!payload || !owner) return;
    const npc = hydrateNpcDialogue(payload, player?.level || 1, player?.quests, player?.class, player?.learnedAbilities, player ?? undefined);
    if (npc) DiscoveredQuestsStore.recordDiscovered(owner, featuredQuestIds(npc));
    // Re-run only for a new reply or another character; level/quest changes re-arrive as a new payload.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [payload, owner]);
}
